import React, { CSSProperties } from 'react';
import { injectTestId } from '@cvent/nucleus-test-automation';

import { useDividerStyle } from '@hooks/style/useDividerStyle';

interface HorizontalDividerProps {
  testID: string;
}

export const HorizontalDivider = ({ testID }: HorizontalDividerProps): JSX.Element => {
  const { divider } = useDividerStyle();

  return <hr style={divider as CSSProperties} {...injectTestId(`${testID}_horizontal_divider`)} />;
};

export default HorizontalDivider;
